// PackageDetails.jsx
import { useState, useEffect, useRef } from "react";
import { Box, CircularProgress, Divider } from "@mui/material";
import FieldsTable from "@/Components/Tables/FieldsTable";
import { SectionHeader } from "@/Components/Header/SectionsHeader";
import { LuX } from "@/Components/Icons/Icons";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";
import { BlackButton } from "@/Components/Buttons/FiledButton";
import {
  useCreatePackageDetailsMutation,
  useUpdatePackageDetailsMutation,
  useDeletePackageDetailsMutation,
  useGetPackageDetailsByMasterIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Container/ContainerPackageSlice";
// import { useGetQuantityQuery } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentMainSlice";
import SuccessDialog from "@/Components/Dialog/SuccessDialog";
import { BiSolidError } from "react-icons/bi";
import { LuCheck } from "@/Components/Icons/Icons";
import { useUser } from "@/Context/UserContext";
import TableGenerator from "@/Utils/FormGenerator/TableGenerator";
import FormDialog from "@/Components/Dialog/FormDialog";
import HighSeaSellerSchema from "@/Config/ImportJob/CreateNewJob/General/HighSeaSellerSchema";
import { useCreateHighSeaSellerMutation } from "@/redux/ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
import { importHookMap } from "@/redux/importHookMap";
import { useGetHighSeaSellerQuery } from "@/redux/ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
import {
  useUpdateHighSeaSellerMutation,
  useDeleteHighSeaSellerMutation,
} from "@/redux/ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
import InputTextField from "@/Components/Form/InputTextField";
import DateSelector from "@/Components/Form/DateSelector";
import InputDropdown from "@/Components/Form/InputDropdown";
import { hookMap } from "@/redux/hookMap";
import { useParams } from "react-router";
import InvoiceQuicikEntrySchema from "@/Config/Export/CreateNewJob/Invoice/InvoiceQuicikEntrySchema";

export default function InvoiceQuickEntry({ onClose }) {
  const [rows, setRows] = useState([]);

  // const { data: quantityOptions = [] } = useGetQuantityQuery();
  const [loading, setLoading] = useState(false);
  const [successDialogConfig, setSuccessDialogConfig] = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const { exporterMasterId, formData, setFormData } = useUser();
  const {
    data: highSeaSellerData,
    isFetching,
    error,
    refetch: refetchHighSeaSeller,
  } = useGetHighSeaSellerQuery({ id: exporterMasterId });
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [formDialogData, setFormDialogData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef();
  const [isDeleting, setIsDeleting] = useState(false);
  const [invoiceId, setInvoiceId] = useState(null);
  const [currencyData, setCurrencyData] = useState(null);
  const [isAutoFilled, setIsAutoFilled] = useState(false);
  const [prefillData, setPrefillData] = useState({
    invoiceNo: "",
    invoiceDate: null,
    currency: "",
    TOI: "",
  });
  const invoice = formData["invoiceMain"] || [];

  const invoiceOptions = [
    { value: "add_new", label: "Add New Invoice" }, // ⭐ NEW OPTION
    ...invoice.map((invoice) => ({
      value: invoice.exportInvoiceId,
      label: invoice.exportInvoiceNumber,
    })),
  ];
  const selectedInvoiceId = invoice.find(
    (inv) => inv.exportInvoiceId === invoiceId
  );

  // 🔹 Save button disabled if any row missing required fields

  const { fetch: fetchInvoice, data, isLoading } = hookMap.invoiceMain();
  const exchangeRate = hookMap["getExchange"];
  const { currentData } = exchangeRate();
const [isAddEnabled, setIsAddEnabled] = useState(false);

  const { exporterId } = useParams(); // Get exporterMasterId from UserContext

  useEffect(() => {
    if (!exporterId) return;

    const loadData = async () => {
      try {
        if (!formData.invoiceMain?.length) {
          const invoices = await fetchInvoice({ id: exporterId });
          setFormData((prev) => ({ ...prev, invoiceMain: invoices || [] }));
        }
      } catch (err) {
        console.error("Failed to load data:", err);
      }
    };

    loadData();
  }, [exporterId]);

  const handleChange = (e) => {
    if (e === "add_new") {
      setPrefillData({
        invoiceNo: "",
        invoiceDate: null,
        currency: "",
        TOI: "",
      });
      setInvoiceId(e);
      setIsAutoFilled(false);
      return;
    }
    console.log(e, "e check");
    setInvoiceId(e);
    const selectedInvoiceId = invoice.find((inv) => inv.exportInvoiceId === e);

    console.log(
      selectedInvoiceId,
      "selectted",
      selectedInvoiceId.exportInvoiceDate
    );
    if (selectedInvoiceId) {
      setPrefillData({
        invoiceNo: selectedInvoiceId.exportInvoiceNumber || "",
        invoiceDate: selectedInvoiceId.exportInvoiceDate || null,
        currency: selectedInvoiceId.exportCurrency || "",
        TOI: selectedInvoiceId.exportInvoiceTOI || "",
      });
      setIsAutoFilled(true);
    }

    // handleRowSelect(e, "invoiceMain")
  };
  const TOIData = [
    { label: "FOI", value: "FOI" },
    { label: "CIF", value: "CIF" },
    { label: "C&F", value: "C&F" },
    { label: "C&I", value: "C&I" },
  ];

  const handleActions = () => {};

  const handleCloseForm = () => {
    setIsEditing(false);
    setFormDialogData({});
    setShowForm(false);
  };

  useEffect(() => {
  const { invoiceNo, invoiceDate, TOI, currency } = prefillData;

  const allFilled =
    invoiceNo?.toString().trim() !== "" &&
    invoiceDate !== null &&
    TOI?.toString().trim() !== "" &&
    currency?.toString().trim() !== "";

  setIsAddEnabled(allFilled);
}, [prefillData]);


  const handlers = {
    // handleEdit: (row) => {
    //   if (!row) return;
    //   console.log(row, "row chck");
    //   setFormDialogData(row);
    //   setHighSeaSellerId(row.id);
    //   setIsEditing(true);
    //   setShowForm(true);
    // },
    // handleRemove: async (row) => {
    //   try {
    //     await handleDelete(row);
    //   } catch (err) {
    //     console.error("Failed to delete:", err);
    //   }
    // },
    // handleView: (row) => {
    //   if (!row) return;
    //   const fileObjectKey = Object.keys(row).find(
    //     (key) =>
    //       row[key] &&
    //       typeof row[key] === "object" &&
    //       row[key].filePath &&
    //       row[key].fileName
    //   );
    //   if (fileObjectKey) {
    //     const fileData = row[fileObjectKey];
    //     try {
    //       const fileUrl = `${import.meta.env.VITE_BASE_FILE_URL}${fileData.filePath}`;
    //       window.open(encodeURI(fileUrl), "_blank");
    //     } catch (err) {
    //       console.error("View failed:", err);
    //     }
    //     return;
    //   }
    // },
  };

  const visibleFieilds = [
    { key: "srNo", label: "Sr No", width: "70px" },
    { key: "importerHighSeaSellerName", label: "Seller Name", width: "120px" },
    { key: "importerHighSeaSellerCity", label: "City", width: "120px" },
    { key: "importerHighSeaSellerCountry", label: "Country", width: "180px" },
  ];

  // 🟡 Handle Value Change

  // 🗑️ Delete Row
  const handleDelete = async (row) => {
    try {
      setIsDeleting(true);
      const res = await deleteFn({ id: row.id }).unwrap();

      if (res?.statusCode === 200) {
        setSuccessDialogConfig({
          label: "Success",
          title: "",
          subtitle: (
            <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
              {res?.message || "Deleted successfully"}
            </strong>
          ),
          buttonText: "OK",
          IconComponent: LuCheck,
        });
        setShowSuccessDialog(true);

        // ✅ Just refetch data after successful delete
        await refetchHighSeaSeller();
      }
    } catch (err) {
      console.error("Delete failed:", err);
      setSuccessDialogConfig({
        label: "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {err?.data?.message || "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });
      setShowSuccessDialog(true);
    } finally {
      setIsDeleting(false);
    }
  };

  // ➕ Add Row
  const handleAddRow = () => {
    setShowForm(true);
  };

  // 💾 Save (Create + Update)
  // const handleSave = async () => {
  //   setLoading(true);
  //   try {
  //     console.log("rows to send to API", formData);
  //     const filledData = formRef.current ? await formRef.current.submit() : {};
  //     console.log("filledData", filledData);

  //     if (!Object.keys(filledData).length) return;

  //     const updatedData = Object.fromEntries(
  //       Object.entries(filledData).map(([key, val]) => [key, val?.id ?? val])
  //     );

  //     let response;
  //     if (isEditing && highSeaSellerId) {
  //       response = await update({
  //         id: importerMasterId,
  //         subId: highSeaSellerId,
  //         ...updatedData,
  //       }).unwrap();
  //     } else {
  //       response = await create({
  //         id: importerMasterId,
  //         ...updatedData,
  //       }).unwrap();
  //     }

  //     console.log("response", response);

  //     // ✅ Check API response before showing success
  //     if (response?.statusCode === 200) {
  //       setSuccessDialogConfig({
  //         label: "Success",
  //         title: "",
  //         subtitle: (
  //           <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
  //             {response.message || "Data saved successfully"}
  //           </strong>
  //         ),
  //         buttonText: "OK",
  //         IconComponent: LuCheck,
  //       });
  //     } else {
  //       setSuccessDialogConfig({
  //         label: "Failure",
  //         title: "",
  //         subtitle: (
  //           <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
  //             {response?.message || "Save failed, please try again"}
  //           </strong>
  //         ),
  //         buttonText: "OK",
  //         status: "error",
  //         icon: BiSolidError,
  //       });
  //     }

  //     setShowSuccessDialog(true);
  //   } catch (error) {
  //     console.error("❌ Save failed:", error);
  //     setSuccessDialogConfig({
  //       label: "Failure",
  //       title: "",
  //       subtitle: (
  //         <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
  //           {error?.data?.message || "Something went wrong"}
  //         </strong>
  //       ),
  //       buttonText: "OK",
  //       status: "error",
  //       icon: BiSolidError,
  //     });
  //     setShowSuccessDialog(true);
  //   } finally {
  //     setLoading(false);
  //     setShowForm(false);
  //   }
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--gray-0)",
        width: "100%",
        maxWidth: "100vw",
        height: 700,
        // maxHeight: 600,
        mb: 2,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 2,
          m: 0.5,
        }}
      >
        <SectionHeader title={"Quick Entry for Invoice and Products"} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: 4,
            alignItems: "center",
            pr: 2,
            m: 1,
          }}
        >
          <BlackButton
            variant="contained"
            color="primary"
            onClick={handleAddRow}
            disabled={!isAddEnabled}  
            label="Add"
            icon="LuPlus"
            sx={{ border: "none", width: 100, mb: 0 }}
          />
          <LuX size={20} style={{ cursor: "pointer" }} onClick={onClose} />
        </Box>
      </Box>
      <Divider />

      {/* Add Button */}

      {/* Table */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <Box
          sx={{
            border: "1px solid var(--gray-400)",
            borderRadius: 2,
            p: 2,
            m: 2,
            backgroundColor: "var(--gray-50)",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <InputDropdown
            label="Select Invoice"
            options={invoiceOptions}
            value={invoiceId}
            onChange={(val) => handleChange(val)}
            placeholder="Choose Invoice"
            width="50%"
          />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 2,
            }}
          >
            <InputTextField
              label="Invoice No"
              value={prefillData.invoiceNo || ""}
              disabled={isAutoFilled}     // Disable only if auto-filled
                onChange={(e) => {
                setPrefillData({ ...prefillData, invoiceNo: e.target.value });
                setIsAutoFilled(false); // User is modifying → remove auto mode
              }}
            />

            <DateSelector
              label="Invoice Date"
              value={prefillData.invoiceDate}
              onChange={(newVal) => {
                setPrefillData({ ...prefillData, invoiceDate: newVal });
                setIsAutoFilled(false);
              }}

              // disabled
            />

            <InputDropdown
              label="TOI"
              options={TOIData}
              value={prefillData.TOI || ""}
              onChange={(val) => {
                setPrefillData({ ...prefillData, TOI: val });
                setIsAutoFilled(false);
              }}
              // disabled
            />

            <InputTextField
              label="Currency"
              options={currentData}
              value={prefillData.currency}
              onChange={(e) => {
                setPrefillData({ ...prefillData, currency: e.target.value });
                setIsAutoFilled(false);
              }}
              // disabled
            />
          </Box>
        </Box>

        {/* Loader + Table */}
        {isFetching && (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
              width: "100%",
              gap: 1,
            }}
          >
            <CircularProgress size={40} sx={{ color: "var(--brand-600)" }} />
          </Box>
        )}

        {!isFetching && (
          <TableGenerator
            compKey="quickEntryData"
            visibleFields={visibleFieilds}
            label="Quick Entry"
            handlers={handlers}
          />
        )}
      </Box>

      {/* Footer */}
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          justifyContent: "flex-end",
          borderTop: "1px solid var(--gray-400)",
        }}
      >
        <OutLinedButton
          variant="contained"
          color="secondary"
          onClick={onClose}
          label="Cancel"
          sx={{ width: 100, mt: 3 }}
        />
        <BlackButton
          variant="contained"
          color="secondary"
          onClick={handleSave}
          label={loading ? "Saving..." : "Save"}
          disabled={loading || isSaveDisabled}
          sx={{ mr: 5, width: 100, mt: 3 }}
        />
      </Box> */}

      <SuccessDialog
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        {...successDialogConfig}
      />
      {showForm && (
        <FormDialog
          title={isEditing ? `Edit Quick Entry` : `Add Quick Entry`}
          schema={InvoiceQuicikEntrySchema}
          initialData={formDialogData}
          isEditing={isEditing}
          onSubmit={() => handleSave("table")}
          handleActions={handleActions}
          onClose={handleCloseForm}
          showCancelButton={true}
          showSubmitButton={true}
          cancelLabel="Cancel"
          submitLabel={isEditing ? "Save" : "Add"}
          loading={loading}
          ref={formRef}
          // disabled={!isRequiredFieldFilled}
        />
      )}
    </Box>
  );
}
